import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from "react-router-dom";
import "../styles/login/login.css";
import Header from "./Header";
import Footer from "./Footer";
const apiUrl = process.env.REACT_APP_OPT_SERVER;

export default function Login() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { lang } = useParams();
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const clearErrorAfterDelay = () => {
    setTimeout(() => {
      setError("");
    }, 5000);
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setError(t('err-email-empty'));

      clearErrorAfterDelay();
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      setError(t('err-email'));
      clearErrorAfterDelay();
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${apiUrl}/generate-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim() }),

      });

      console.log(response);
      console.log("api", apiUrl);

      if (!response.ok) {
        setError(t('err-otp'));
        clearErrorAfterDelay();
        setLoading(false);
        return;
      }
      setMessage(t('otp-sent'));
      navigate(`/lang/${lang}/verify-otp`, { state: { email: email.trim() } });
    } catch (error) {
      console.error(error);
      setError(t('err-otp-network'));
      clearErrorAfterDelay();
      setLoading(false);
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (error) setError("");
  };

  const handleBack = () => {
    navigate(`/lang/${lang}/`);
  };


  return (
    <>
      <Header hideNav={true} hideHamburger={true} />
      <div className="login-container">
        <div className="login-form">
          <form onSubmit={handleSendOtp}>

            {message && (
              <div
                className="alert-box success"
                role="alert"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 21a9 9 0 0 0 7.51-13.961l-7.155 7.95a2 2 0 0 1-2.687.262L6.4 12.8a1 1 0 0 1 1.2-1.6l3.268 2.451l7.346-8.161A9 9 0 1 0 12 21" clip-rule="evenodd" /></svg>
                <span>{message}</span>
                <button onClick={() => setMessage("")}>&times;</button>
              </div>
            )}

            {error && (
              <div
                className="alert-box error"
                role="alert"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24"><path fill="currentColor" d="M12 17q.425 0 .713-.288T13 16t-.288-.712T12 15t-.712.288T11 16t.288.713T12 17m0-4q.425 0 .713-.288T13 12V8q0-.425-.288-.712T12 7t-.712.288T11 8v4q0 .425.288.713T12 13m0 9q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22" /></svg>
                <span>{error}</span>
                <button onClick={() => setError("")}>&times;</button>
              </div>
            )}
            <div className="login-logo">
              <img src="/assets/MPTC_Logo.png" alt="Logo" className="logo-image" />
            </div>

            <label className="login-label">
              {t('login-label')}{" "}
              <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="e.g. bopha@gov.kh"
              value={email}
              onChange={handleEmailChange}
              className={`login-input ${error ? "error" : ""}`}
              disabled={loading}
            />

            {/* {error && <p className="error">{error}</p>} */}

            <button type="submit" className="login-button" disabled={loading}>
              {loading ? t('loading') : t('login')}
            </button>

            <button onClick={handleBack} className="back-link">
              <svg
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
                className="back-icon"
              >
                <path d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"></path>
                <path d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"></path>
              </svg>
              {t('back')}
            </button>
          </form>
          <img src="/assets/Desktop_background.svg" alt="banner" className="desktop_banner" />
          <img src="/assets/Mobile_background.svg" alt="banner" className="mobile_banner" />
        </div>
      </div>
      <Footer hideFooter={true} />
    </>

  );
}
